'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagJeAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M3.8147e-06 -3.09944e-06H28V20H3.8147e-06V-3.09944e-06Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M15.7408 2.66666H13.5926L13.6799 2.61546L12.693 2.04563L13.9689 2.18808L13.7895 1.33333L14.6667 2.04563L15.5438 1.33333L15.3645 2.18808L16.6403 2.04563L15.6535 2.61546L15.7408 2.66666Z",
          fill: "#FAEF32"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12.6667 5.16666C12.6667 4.79586 12.6667 4.38228 12.6667 3.99994C12.6667 3.26356 13.2636 2.66666 14 2.66666H15.3333C16.0697 2.66666 16.6667 3.26356 16.6667 3.99994C16.6667 4.38228 16.6667 4.79586 16.6667 5.16666C16.6667 6.95238 14.6667 7.66666 14.6667 7.66666C14.6667 7.66666 12.6667 6.95238 12.6667 5.16666Z",
          fill: "#E3243B"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M14.3333 7C14.3333 6.8159 14.4826 6.66666 14.6667 6.66666C14.8508 6.66666 15 6.8159 15 7C15 7.18409 14.8508 7.33333 14.6667 7.33333C14.4826 7.33333 14.3333 7.18409 14.3333 7Z",
          fill: "#FAEF32"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M13.3333 5.66666C13.3333 5.48257 13.4826 5.33333 13.6667 5.33333H15.6667C15.8508 5.33333 16 5.48257 16 5.66666C16 5.85076 15.8508 6 15.6667 6H13.6667C13.4826 6 13.3333 5.85076 13.3333 5.66666Z",
          fill: "#FAEF32"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M13.3333 4.33333C13.3333 4.14924 13.4826 4 13.6667 4H15.6667C15.8508 4 16 4.14924 16 4.33333C16 4.51743 15.8508 4.66666 15.6667 4.66666H13.6667C13.4826 4.66666 13.3333 4.51743 13.3333 4.33333Z",
          fill: "#FAEF32"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M27 -1.52588e-05L28 -3.09944e-06V2.49998L16.9836 10.4732L28 18L28 20H26L14.659 12.1009L3.5 20L3.8147e-06 20L0 19L12.3344 10.4732L3.8147e-06 2V-3.09944e-06H2L14.659 8.84546L27 -1.52588e-05Z",
          fill: "#E3243B"
        }
      )
    ]
  }
);
const VpFlagJeAsset = forwardRef(FlagJeAsset);

export { VpFlagJeAsset as default };
